export default {
    getSeasons() {
        return axios.get('/api/referee/seasons');
    },
    getVenues() {
        return axios.get('/api/referee/venues');
    },
    getRosterByCurrentUser(seasonId, rosterDate, rosterType) {
        return axios.post('/api/referee/roster', { 'season': seasonId, 'roster': rosterDate, 'type': rosterType});
    },
    getAvailabilityByCurrentUser(seasonId, venueId) {
        return axios.get('/api/referee/availability/' + seasonId + '/' + venueId);
    },
    postAvailabilityByCurrentUser(seasonId, venueId, refGameTimes, unavailability) {
        return axios.post('/api/referee/availability', { 'season': seasonId , 'venue': venueId, 'availability': refGameTimes, 'unavailability': unavailability});
    },
};
